module.exports = __webpack_public_path__ + "static/img/8.35b11517.jpg";